import { Helmet } from 'react-helmet';

const brandTitleSuffix = ' - Mercator AI';

type Props = {
  // Shows up as the tab's text.
  title: string;
};

/**
 * Wrapper to define page meta data.
 */
const PageMetadata = ({ title }: Props) => {
  return (
    <Helmet>
      <title>{`${title}${brandTitleSuffix}`}</title>
    </Helmet>
  );
};

export default PageMetadata;
